import Vue from 'vue'
import VueRouter from 'vue-router'
import SelfSignUpView from '../views/SelfSignUpView.vue'
import SuccessView from '../views/SuccessView.vue'
import ExpiredView from '../views/ExpiredView.vue'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
  },
  {
    path: '/sign-up/:keyCode',
    name: 'Sign up',
    component: SelfSignUpView,
    props: true
  },
  {
    path: '/success',
    name: 'Success',
    component: SuccessView,
    exact: true
  },
  {
    path: '/expired',
    name: 'Expired Link',
    component: ExpiredView,
    exact: true
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
